module.exports = __webpack_public_path__ + "assets/img/05.admin-server.13f81923.png";